import Vue from 'vue'
import Router from 'vue-router'
// import login from '../pages/login/login'
// const devcenter =  () => import('src/pages/devCenter/devCenterIndex')
import devcenter from 'src/pages/devCenter/devCenterIndex'

// import CaseOne from '../pages/sample/sample-page/cases/case-one'
// import CaseTwo from '../pages/sample/sample-page/cases/case-two'
// import CaseThree from '../pages/sample/sample-page/cases/case-three'
// import CaseFour from '../pages/sample/sample-page/cases/case-four'
// import CaseFive from '../pages/sample/sample-page/cases/case-five'
// import CaseSix from '../pages/sample/sample-page/cases/case-six'
// import CaseSeven from '../pages/sample/sample-page/cases/case-seven'

// 开发者中心
import getStarted from 'src/pages/devCenter/getStarted/getStartedIndex'
import devDocs from 'src/pages/devCenter/devDocs/devDocsIndex'
import consoleLab from 'src/pages/devCenter/consoleLab/consoleIndex'
import commonQuestion from 'src/pages/devCenter/commonQuestion/commonQuestionIndex'
//20210309 by wyx
import updateLogs from 'src/pages/devCenter/updateLogs/updateLogsIndex'
import logDetail from 'src/pages/devCenter/updateLogs/logDetail'
// import applicationScenarios from 'src/pages/devCenter/applicationScenarios/applicationScenariosIndex';

// 控制台部分
import myAccount from 'src/pages/devCenter/consoleLab/myAccount/myAccount'
import myApp from 'src/pages/devCenter/consoleLab/myapp/myApp'
import fileManagement from 'src/pages/devCenter/consoleLab/fileManagement/fileManagement'
import shareManagement from 'src/pages/devCenter/consoleLab/shareManagement/shareManagement'
import viewmodel from 'src/components/ViewModel/ViewModel'
import sample from '../pages/sample/sample'
import features from '../pages/features/features'
import index from '../pages/index/index'
import ModelAssemble from '../pages/devCenter/consoleLab/ModelAssemble/ModelAssemble.vue'
import ModelCompared from '../pages/devCenter/consoleLab/ModelCompared/ModelCompared.vue'
import shareView from '../pages/ShareView/ShareView'
import modelMissShare from '../pages/ShareView/modelMissShare'
import modelCancelShare from '../pages/ShareView/modelCancelShare'
//20210327 by wyx
import lodLoad from '../pages/devCenter/consoleLab/lodLoad/lodLoad.vue'

import lodAssemble from '../pages/devCenter/consoleLab/lodAssemble/lodAssemble.vue'

// import SampleModel from '../pages/sample/sample-page/sample-model'
// import SampleScenarios from '../pages/sample/sample-page/sample-scenarios'
const ScenarioOne = () =>
  import(/* webpackChunkName: 'Scenario' */ '../pages/sample/sample-page/scenarios/scenario-one')
const ScenarioTwo = () =>
  import(/* webpackChunkName: 'Scenario' */ '../pages/sample/sample-page/scenarios/scenario-two')
const ScenarioThree = () =>
  import(/* webpackChunkName: 'Scenario' */ '../pages/sample/sample-page/scenarios/scenario-three')
const ScenarioFour = () =>
  import(/* webpackChunkName: 'Scenario' */ '../pages/sample/sample-page/scenarios/scenario-four')
const ScenarioFive = () =>
  import(/* webpackChunkName: 'Scenario' */ '../pages/sample/sample-page/scenarios/scenario-five')

// import ScenarioOne from '../pages/sample/sample-page/scenarios/scenario-one'
// import ScenarioTwo from '../pages/sample/sample-page/scenarios/scenario-two'
// import ScenarioThree from '../pages/sample/sample-page/scenarios/scenario-three'
// import ScenarioFour from '../pages/sample/sample-page/scenarios/scenario-four'
// import ScenarioFive from '../pages/sample/sample-page/scenarios/scenario-five'

// import SampleCases from '../pages/sample/sample-page/sample-cases'

const CaseOne = () => import(/* webpackChunkName: 'Cases' */ '../pages/sample/sample-page/cases/case-one')
const CaseTwo = () => import(/* webpackChunkName: 'Cases' */ '../pages/sample/sample-page/cases/case-two')
const CaseThree = () => import(/* webpackChunkName: 'Cases' */ '../pages/sample/sample-page/cases/case-three')
const CaseFour = () => import(/* webpackChunkName: 'Cases' */ '../pages/sample/sample-page/cases/case-four')
const CaseFive = () => import(/* webpackChunkName: 'Cases' */ '../pages/sample/sample-page/cases/case-five')
const CaseSix = () => import(/* webpackChunkName: 'Cases' */ '../pages/sample/sample-page/cases/case-six')
const CaseSeven = () => import(/* webpackChunkName: 'Cases' */ '../pages/sample/sample-page/cases/case-seven')

// 登录部分
// import { isLogin } from 'src/utils/loginUtils'

// import document from '../pages/document/document'
// import DocumentGuide from '../pages/document/document-page/document-guide'
// import DocumentJsApi from '../pages/document/document-page/document-js-api'
// import DocumentServerApi from '../pages/document/document-page/document-server-api'
// import help from '../pages/help/help'
// import HelpGetStart from '../pages/help/help-page/help-get-start'
// import JsApiDemo from '../pages/help/help-page/js-api-demo'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'index',
      component: index,
    },
    // 登录部分
    {
      path: '/login',
      name: 'login',
      redirect: '/devcenter/console/myaccount',
    },
    {
      path: '/index',
      name: 'index',
      redirect: '/',
    },
    {
      path: '/sample',
      component: sample,
      // redirect:'/sample/model',
      children: [
        // {
        //   path:'/sample/model',
        //   component:SampleModel
        // },
        // {
        //   path:'/sample/scenarios',
        //   component:SampleScenarios
        // },
        {
          path: '/sample/scenarios/scenario-one',
          component: ScenarioOne,
        },
        {
          path: '/sample/scenarios/scenario-two',
          component: ScenarioTwo,
        },
        {
          path: '/sample/scenarios/scenario-three',
          component: ScenarioThree,
        },
        {
          path: '/sample/scenarios/scenario-four',
          component: ScenarioFour,
        },
        {
          path: '/sample/scenarios/scenario-five',
          component: ScenarioFive,
        },
        // {
        //   path:'/sample/cases',
        //   component:SampleCases
        // },
        {
          path: '/sample/cases/case-one',
          component: CaseOne,
        },
        {
          path: '/sample/cases/case-two',
          component: CaseTwo,
        },
        {
          path: '/sample/cases/case-three',
          component: CaseThree,
        },
        {
          path: '/sample/cases/case-four',
          component: CaseFour,
        },
        {
          path: '/sample/cases/case-five',
          component: CaseFive,
        },
        {
          path: '/sample/cases/case-six',
          component: CaseSix,
        },
        {
          path: '/sample/cases/case-seven',
          component: CaseSeven,
        },
      ],
    } /* {
      path:'/help',
      component:help,
      // redirect:'/help/get-start',
      children:[
        {
          path:'/help/get-start',
          component:HelpGetStart
        },{
          path:'/help/js-api-demo',
          component:JsApiDemo
        }
      ]
    }, */,
    /* {
  path:'/document',
  component:document,
  // redirect:'/document/guide',
  children:[
    {
      path:'/document/guide',
      component:DocumentGuide
    },{
      path:'/document/server-api',
      component: DocumentServerApi
    },{
      path:'/document/js-api',
      component:DocumentJsApi
    }
  ]
}, */ {
      path: '/features',
      name: 'features',
      component: features,
    },
    {
      path: '/devcenter',
      name: 'devcenter',
      redirect: '/devcenter/getstarted',
      component: devcenter,
      children: [
        {
          path: 'getstarted',
          name: 'getStarted',
          component: getStarted,
        },
        {
          path: 'devdocs',
          name: 'devDocs',
          component: devDocs,
        },
        {
          path: 'console',
          name: 'consoleLab',
          component: consoleLab,
          redirect: 'console/myaccount',
          // 组件内路由守卫
          // beforeEnter: (to, from, next) => {
          //   // 判断本地的localStorage
          //   debugger
          //   next()
          //   // if (isLogin()) {
          //   //   next()
          //   // } else {
          //   //   next('/login')
          //   // }
          // },
          children: [
            {
              path: 'myaccount',
              name: 'myaccount',
              component: myAccount,
            },
            {
              path: 'myapp',
              name: 'myapp',
              component: myApp,
            },
            {
              path: 'fileManagement',
              name: 'fileManagement',
              component: fileManagement,
            },
            {
              path: 'shareManagement',
              name: 'shareManagement',
              component: shareManagement,
            },
            // 解决页面加载存在侧边栏问题
            // {
            //     path: 'view',
            //     name: 'viewmodel',
            //     component: viewmodel,
            // },
            {
              path: 'modelAssemble',
              name: 'modelAssemble',
              component: ModelAssemble,
            },
            {
              path: 'modelCompared',
              name: 'modelCompared',
              component: ModelCompared,
            },
            //20210327 by wyx
            {
              path: 'lodLoad',
              name: 'lodLoad',
              component: lodLoad,
            },
            {
              path: 'lodAssemble',
              name: 'lodAssemble',
              component: lodAssemble,
            },
          ],
        },
        {
          path: 'console/view',
          name: 'viewmodel',
          component: viewmodel,
        },
        {
          path: 'commonQuestion',
          name: 'commonQuestion',
          component: commonQuestion,
        },
        //20210309 by wyx
        {
          path: 'updateLogs',
          name: 'updateLogs',
          component: updateLogs,
        },
        {
          path: 'updateLogs/logDetail/:id',
          name: 'logDetail',
          component: logDetail,
        },
        // {
        //     path: 'applicationScenarios',
        //     name: 'applicationScenarios',
        //     component: applicationScenarios,
        // },
      ],
    },
    // {
    //   path: '/devcenter/console/shareView',
    //   name: 'shareView',
    //   component: shareView,
    // },
    {
      path: '/devcenter/shareView/:shareId',
      name: 'shareView',
      component: shareView,
    },
    {
      path: '/devcenter/shareModelView/modelMissShare',
      name: 'modelMissShare',
      component: modelMissShare,
    },
    {
      path: '/devcenter/shareModelView/modelCancelShare',
      name: 'modelCancelShare',
      component: modelCancelShare,
    },
    // {
    //     path: '/playground/obv/:id',
    //     redirect: () => location.href
    // },
  ],
  // 20211130 by zy 页面跳转后定位至顶部
  scrollBehavior (to, from, savedPosition) {
    return { x: 0, y: 0 }
  },
})



// WEBPACK FOOTER //
// ./src/router/index.js